import ImportSiswaBaru from "../../../../../components/categories/superadmin/master_data/import_siswa_baru/Home"

export default function Home() {  
  return (
    <ImportSiswaBaru />
  );
}
